/**
 * Words for a skill's choice rows (Skills UX pass 2026-09-06). Values are the
 * backend's (`skill_levels.py` is the one ladder; the engines read the rest).
 */
export const SKILL_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Whenever' },
  { value: 'medium', label: 'Normal' },
  { value: 'high', label: 'Important' },
]

/** The five rungs, lowest first, each with what it means in plain words. */
export const LEVEL_OPTIONS: Array<{ value: string; label: string; capability: string }> = [
  { value: 'novice', label: 'Novice', capability: 'Not yet able to do it' },
  { value: 'beginner', label: 'Beginner', capability: 'Can follow an example' },
  { value: 'developing', label: 'Developing', capability: 'Can do it with some guidance' },
  { value: 'proficient', label: 'Proficient', capability: 'Can do it on my own in normal cases' },
  { value: 'advanced', label: 'Advanced', capability: 'Can handle the hard and unfamiliar cases' },
]

export const CADENCE_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'most_days', label: 'Most days' },
  { value: 'few_times_a_week', label: 'A few times a week' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'now_and_then', label: 'Now and then' },
]
